import React from "react";

import clsx from "clsx";
import PropTypes from "prop-types";

const ModalBody = ({ children, title, classNames }) => {
  const containerBodyClassName = classNames?.["containerBody"] || "";

  return (
    <>
      {title && (
        <div className="conv__body__header_block_user_modal_title">{title}</div>
      )}
      <div className={clsx(["modal__container__body", containerBodyClassName])}>
        {children}
      </div>
    </>
  );
};

ModalBody.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ModalBody;
